import { CaseFileStaticItems } from '../../../../utilities/Constants';
import { CaseManagerControl } from './CaseManagerControl';
import { CaseNumberControl } from './CaseNumberControl';
import { CasePriorityControl } from './CasePrioirtyControl';
import { CaseStatusControl } from './CaseStatusControl';
import { ISameCaseEasyUpdateCaseModel } from '../../../../pages/quad/same-case-easy-update/ISameCaseEasyUpdateModel';
import { LocalCounselControl } from './LocalCounselControl';
import { UniqueCaseIdControl } from './UniqueCaseIdControl';

export function StaticItemInputControl(props: {
    caseModel: ISameCaseEasyUpdateCaseModel | undefined;
    onChange: (staticItemId: number, value: any) => void;
    readonly: boolean;
    staticItemId: number;
    zoneGuid: string;
}) {
    if (!props.caseModel) return null;

    switch (props.staticItemId) {
        case CaseFileStaticItems.CaseManager.Id:
            return (
                <CaseManagerControl
                    value={props.caseModel.caseManagerUser?.guid}
                    isPrimary
                    onChange={(selectedItem) =>
                        props.onChange(CaseFileStaticItems.CaseManager.Id, selectedItem)
                    }
                    zoneGuid={props.zoneGuid}
                    readonly={!props.caseModel.canEdit || props.readonly}
                />
            );
        case CaseFileStaticItems.AlternateCaseManager.Id:
            return (
                <CaseManagerControl
                    value={props.caseModel.alternateCaseManagerUser?.guid}
                    isPrimary={false}
                    onChange={(selectedItem) =>
                        props.onChange(CaseFileStaticItems.AlternateCaseManager.Id, selectedItem)
                    }
                    zoneGuid={props.zoneGuid}
                    readonly={!props.caseModel.canEdit || props.readonly}
                />
            );
        case CaseFileStaticItems.LocalCounsel.Id:
            return (
                <LocalCounselControl
                    value={
                        props.caseModel.defenseCounsels?.find((dc) => dc.priority === 1)?.guid ?? ''
                    }
                    onChange={(selectedItem) =>
                        props.onChange(CaseFileStaticItems.LocalCounsel.Id, selectedItem)
                    }
                    zoneGuid={props.zoneGuid}
                    readonly={!props.caseModel.canEdit || props.readonly}
                />
            );
        case CaseFileStaticItems.CasePriority.Id:
            return (
                <CasePriorityControl
                    value={props.caseModel.priority}
                    onChange={(selectedItem) =>
                        props.onChange(
                            CaseFileStaticItems.CasePriority.Id,
                            !selectedItem ? undefined : selectedItem?.value === 'true'
                        )
                    }
                />
            );
        case CaseFileStaticItems.UniqueCaseID.Id:
            return (
                <UniqueCaseIdControl
                    onChange={(value) => props.onChange(CaseFileStaticItems.CaseNumber.Id, value)}
                    value={props.caseModel.uniqueCaseId}
                    readonly={!props.caseModel.canEdit || props.readonly}
                />
            );
        case CaseFileStaticItems.CaseNumber.Id:
            return (
                <CaseNumberControl
                    onChange={(value) => props.onChange(CaseFileStaticItems.CaseNumber.Id, value)}
                    value={props.caseModel.caseNumber}
                    readonly={!props.caseModel.canEdit || props.readonly}
                />
            );
        case CaseFileStaticItems.CaseStatus.Id:
            return (
                <CaseStatusControl
                    onChange={(value) => props.onChange(CaseFileStaticItems.CaseStatus.Id, value)}
                    value={props.caseModel.caseStatus}
                    readonly={!props.caseModel.canEdit || props.readonly}
                />
            );
        default:
            return null;
    }
}
